import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { Button } from '@components/Button';
import { objArrayToCSV } from '@utils/commonUtils';

const StyledButton = tw(Button.Primary)`w-auto px-4 py-2 text-[14px] h-auto`;

type AudioReportCSVDataType = { [key: string]: string };

export const DownloadProcessingUsageCSV = ({
  data = [],
  interval,
  fileName,
  ...rest
}: {
  data: AudioReportCSVDataType[];
  interval: string;
  fileName: string;
}) => {
  const { t } = useTranslation();
  const [_data, _setData] = useState<AudioReportCSVDataType[]>([]);

  useEffect(() => {
    if (!data.length) return;

    const headObject: AudioReportCSVDataType = {
      interval_segment: `Interval: ${interval}`,
      audio_count: 'Audio count',
      audio_duration_sec: 'Duration (seconds)',
    };

    _setData([headObject, ...data]);
  }, [data]);

  const downloadCSV = () => {
    const csvData = new Blob([objArrayToCSV(_data)], {
      type: 'text/csv',
    });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <StyledButton onClick={downloadCSV} {...rest}>
      {t('account_module.settings_page.audio_processing_report.download_csv')}
    </StyledButton>
  );
};
